import { render } from "./ChartItem.vue?vue&type=template&id=56e8a259"
import script from "./ChartItem.vue?vue&type=script&lang=js"
export * from "./ChartItem.vue?vue&type=script&lang=js"

import "./ChartItem.vue?vue&type=style&index=0&id=56e8a259&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__